module.exports = __webpack_public_path__ + "img/deleteEvent1.f9c7bb38.png";